// 分类/全部，搜索页另外建
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { InfiniteScroll, SideBar } from 'antd-mobile'
import { DotLoadingInBlock } from '../../../components_renew/common/DotLoadingInBlock'
import { Container, Header, Wrapper } from '../../../components_renew/Layout'
import { TabBar } from '../../../components_renew/Mall/TabBar'
import { ProductListItem } from '../../../components_renew/Mall/ProductListItem'
import {
  clearProductListSearch,
  requestCartData, requestCatalogData,
  requestProductListData,
  setProductDetailsData, setProductListIndex
} from '../../../actions/mallAction'
import { defaultData } from '../../../reducers/mallProductListReducer'
import { handleCatch, postMessage } from '../../../utils'
import { ProductSearchBar } from '../../../components_renew/Mall/ProductSearchBar'
import { withTranslation } from 'react-i18next'
import { PATH } from '../../../constants/PATH'

const tabs = [{
  title: '首页',
  route: PATH.MALL_PRODUCT_CATEGORY,
  key: 'home',
  icon: 'icon-shop',
  t_key: 'tab_1'
}, {
//   title: '分类',
//   route: PATH.MALL_PRODUCT_LIST,
//   icon: 'list'
// }, {
  title: '购物车',
  route: PATH.MALL_SHOPPING_CART,
  key: 'cart',
  icon: 'icon-cart',
  t_key: 'tab_2'
}, {
  title: '订单',
  route: PATH.MALL_ORDER_LIST,
  key: 'order',
  icon: 'icon-form',
  t_key: 'tab_3'
}]

@withRouter
@connect((state) => {
  let { loading, data, index } = state.mallProductList
  const { categories, } = state.mallCatalogs
  let listData = data[index] ? data[index] : defaultData
  return {
    loading,
    index,
    ...listData,
    categories
  }
})
@withTranslation()
class ProductList extends React.PureComponent {
  componentDidMount () {
    let { list, index } = this.props
    if (!(list.length > 0)) {
      this.props.dispatch(requestProductListData({ index }))
    }
    if (!(this.props.categories.length > 0)) {
      this.props.dispatch(requestCatalogData())
    }
    if (index === 'search') {
      this.props.dispatch(setProductListIndex('all'))
    }
  }

  render () {
    let { list, loading, index, keyword, categories, isLastPage, t } = this.props
    return <Container>
      <Header>{t('mall.title')}</Header>
      <ProductSearchBar defaultValue={keyword} onSearch={this.onSearchSubmit}/>
      <Wrapper flex>
        <div className={'flex h-full overflow-hidden'}>
          <SideBar className={'flex-shrink-0'} activeKey={index} onChange={this.onIndexChange}>
            <SideBar.Item key={'all'} title={'全部'}/>
            {categories.map(item => {
              return <SideBar.Item key={item.id} title={item.name}/>
            })}
          </SideBar>
          <div className={'flex-auto overflow-y-auto'}>
            <div>
              {list.map((item, index) => {
                return <ProductListItem key={index}
                                        {...item}
                                        onClick={this.toProductDetails.bind(this, item)}
                                        onIconClick={this.addCart}
                />
              })}
            </div>
            {
              list.length > 0 ?
                <div>
                  <InfiniteScroll hasMore={!isLastPage} loadMore={this.onEndReached}/>
                </div>
                : loading && <DotLoadingInBlock/>
            }
          </div>
        </div>
      </Wrapper>
      <TabBar tabs={tabs} selectedKey={'home'}/>
    </Container>
  }

  onIndexChange = SideIndex => {
    this.props.dispatch(requestProductListData({ index: SideIndex, pageIndex: 1 }))
    // this.props.dispatch()
    this.props.dispatch(setProductListIndex(SideIndex))
  }

  onSearchSubmit = keyword => {
    this.props.dispatch(clearProductListSearch())
    this.props.dispatch(requestProductListData({ index: 'search', pageIndex: 1, keyword }))
    this.props.history.push(window.PATH.MALL_PRODUCT_SEARCH)
  }

  onEndReached = () => {
    let { loading, isLastPage, pageIndex, index } = this.props
    if (loading || isLastPage) return
    this.props.dispatch(requestProductListData({ pageIndex: pageIndex + 1, index }))
  }

  toProductDetails = (data) => {
    this.props.dispatch(setProductDetailsData(data))
    this.props.history.push(`${window.PATH.MALL_PRODUCT_DETAILS}/${data['id']}`)
  }

  addCart = ({ id }) => {
    // 库存不足应该将有服务器判断，而且应在下单时判断
    // if (!(stock > 0)) {
    //   window.toast.fail('库存不足', 1)
    //   return
    // }
    if (!window.axios.getToken()) {
      window.toast.info('请先进行登陆', 1, () => {
        postMessage({ type: 'loginRequest' })
      })
    } else {
      let config = {
        method: 'post', url: window.API.Mall.postCartItem,
        data: { productId: id, productCount: 1 }
      }
      window.toast.show('')
      window.axios.request(config)
        .then(() => {
          this.props.dispatch(requestCartData())
          window.toast.info('已添加至购物车')
        })
        .catch(handleCatch)
    }
  }

}

export { ProductList }
